import React, { useState } from 'react';
import { Button, Field } from './UI';
import { input } from '../styles/inputs';

interface LoginProps {
  onLogin: (code: string) => void;
  accessCode: string;
}

export function LoginScreen({ onLogin, accessCode }: LoginProps) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Simulate async check
    setTimeout(() => {
      if (code === accessCode) {
        onLogin(code);
      } else {
        setError('Code d\'accès incorrect');
        setCode('');
      }
      setIsLoading(false);
    }, 300);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'var(--color-background-secondary)',
        padding: '1rem',
      }}
    >
      <div
        style={{
          background: 'var(--color-background-primary)',
          borderRadius: 'var(--border-radius-lg)',
          padding: '2rem',
          width: '100%',
          maxWidth: 380,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <h1 style={{ margin: '0 0 0.5rem', fontSize: 24, textAlign: 'center' }}>Dashboard Avocat</h1>
        <p
          style={{
            margin: '0 0 2rem',
            fontSize: 13,
            color: 'var(--color-text-secondary)',
            textAlign: 'center',
          }}
        >
          Gestion professionnelle de vos dossiers
        </p>

        <form onSubmit={handleSubmit}>
          <Field label="Code d'accès" required>
            <input
              type="password"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Entrez votre code"
              style={input}
              disabled={isLoading}
              autoFocus
            />
          </Field>

          {error && (
            <div
              style={{
                background: 'rgba(207, 34, 46, 0.1)',
                color: 'var(--color-danger)',
                padding: '0.75rem',
                borderRadius: 'var(--border-radius-md)',
                fontSize: 12,
                marginBottom: '1rem',
              }}
            >
              {error}
            </div>
          )}

          <Button
            type="submit"
            style={{ width: '100%' }}
            disabled={!code || isLoading}
          >
            {isLoading ? 'Vérification...' : 'Se connecter'}
          </Button>
        </form>

        <p
          style={{
            margin: '1rem 0 0',
            fontSize: 11,
            color: 'var(--color-text-tertiary)',
            textAlign: 'center',
          }}
        >
          Code de démo: <code style={{ fontFamily: 'monospace', fontWeight: 500 }}>avocatdemo</code>
        </p>
      </div>
    </div>
  );
}
